export const AGENT_TRUST_RECEIPT_PANEL_ID = 'agentTrustReceiptPanel';

export type AgentTrustReceiptScenarioId = 'CREATED_BY_AI' | 'EDITED_BY_AI' | 'READ_BY_AI';

export type AgentTrustReceiptActor = {
	id: string;
	name: string;
	type: 'agent' | 'person';
};

export type AgentTrustReceiptScenario = {
	id: AgentTrustReceiptScenarioId;
	label: string;
	description: string;
};

export type AgentTrustReceiptSignal = {
	id: string;
	label: string;
	value: string;
};

export type AgentTrustReceipt = {
	contentId: string;
	actor: AgentTrustReceiptActor;
	scenario: AgentTrustReceiptScenario;
	summary: string;
	signals: AgentTrustReceiptSignal[];
};
